import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { getCommercialElectric } from '@/service/production/ProReportShangTong';
export default function useCommercialElectirc(params) {
  var commercialElectric = ref({
    totalSettleValue: 0,
    totalAveragePrice: 0,
    electric: 0,
    totalMoney: 0,
    tonEle: 0,
    totalSingular: 0
  });
  // 获取主机汇总数据
  var getCommercialElectricAsync = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getCommercialElectric(params.value);
          case 2:
            data = _context.sent;
            commercialElectric.value = data;
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function getCommercialElectricAsync() {
      return _ref.apply(this, arguments);
    };
  }();
  return [commercialElectric, getCommercialElectricAsync];
}